export default {
  mc: [
    {
      text: 'wait(time)',
      tooltip: 'wait',
    },
    {
      text: 'postToChat(str)',
      tooltip: 'postToChat',
    },
  ],
  world: [
    {
      text: 'getBlock(x, y, z)',
      tooltip: 'getBlock',
    },
    {
      text: 'getBlockData(x, y, z)',
      tooltip: 'getBlockData',
    },
    {
      text: 'getBlocks(x0, y0, z0, x, y, z)',
      tooltip: 'getBlocks',
    },
    {
      text: 'getHeight(x, y, z)',
      tooltip: 'getHeight',
    },
    {
      text: 'getPlayerId(str)',
      tooltip: 'getPlayerId',
    },
    {
      text: 'getPlayerIds()',
      tooltip: 'getPlayerIds',
    },
    {
      text: 'setBlock(x, y, z, type)',
      tooltip: 'setBlock',
    },
    {
      text: 'setCuboid(x0, y0, z0, x, y, z, type)',
      tooltip: 'setCuboid',
    },
    {
      text: 'setBlocks(x, y, z, list)',
      tooltip: 'setBlocks',
    },
    {
      text: 'buildArc(x, y, z, w, h, type)',
      tooltip: 'buildArc',
    },
    {
      text: 'buildColumn(x, y, z, h, type)',
      tooltip: 'buildColumn',
    },
    {
      text: 'buildSphere(x, y, z, r, type)',
      tooltip: 'buildSphere',
    },
    {
      text: 'buildHome(x, y, z, w, l, h, type, dir)',
      tooltip: 'buildHome',
    },
    {
      text: 'buildWall(x, y, z, w, h, type)',
      tooltip: 'buildWall',
    },
    {
      text: 'spawnCreature(x, y, z, creature)',
      tooltip: 'spawnCreature',
    },
    {
      text: 'setWeather(type)',
      tooltip: 'setWeather',
    },
    {
      text: 'setTime(time)',
      tooltip: 'setTime',
    },
  ],
  player: [
    {
      text: 'getDirection()',
      tooltip: 'getDirection',
    },
    {
      text: 'getPitch()',
      tooltip: 'getPitch',
    },
    {
      text: 'getPos()',
      tooltip: 'getPos',
    },
    {
      text: 'getRotation()',
      tooltip: 'getRotation',
    },
    {
      text: 'setPos(x, y, z)',
      tooltip: 'setPos',
    },
    {
      text: 'move(dir, steps)',
      tooltip: 'move',
    },
    {
      text: 'lookTo(dir)',
      tooltip: 'lookTo',
    },
    {
      text: 'turnLeft()',
      tooltip: 'turnLeft',
    },
    {
      text: 'turnRight()',
      tooltip: 'turnRight',
    },
  ],
  entity: [
    {
      text: 'getDirection(entity)',
      tooltip: 'getDirection',
    },
    {
      text: 'getPitch(entity)',
      tooltip: 'getPitch',
    },
    {
      text: 'getPos(entity)',
      tooltip: 'getPos',
    },
    {
      text: 'getRotation(entity)',
      tooltip: 'getRotation',
    },
    {
      text: 'setPos(entity, x, y, z)',
      tooltip: 'setPos',
    },
  ],
  drones: [
    //Drones
    {
      text: 'createDrone(x, y, z, name)',
      tooltip: 'createDrone',
    },
    {
      text: 'getDrone(name)',
      tooltip: 'getDrone',
    },
    {
      text: 'list()',
      tooltip: 'list',
    },
    {
      text: 'removeDrone(name)',
      tooltip: 'removeDrone',
    },
    {
      text: 'removeAll()',
      tooltip: 'removeAll',
    },
    //Drone
    {
      text: 'moveForward(distance)',
      tooltip: 'moveForward',
    },
    {
      text: 'move(direction, distance)',
      tooltip: 'move',
    },
    {
      text: 'lookTo(direction)',
      tooltip: 'lookTo',
    },
    {
      text: 'turn(pitch, yaw)',
      tooltip: 'turn',
    },
    {
      text: 'turnLeft()',
      tooltip: 'turnLeft',
    },
    {
      text: 'turnRight()',
      tooltip: 'turnRight',
    },
    {
      text: 'breakBlock()',
      tooltip: 'breakBlock',
    },
    {
      text: 'placeBlock(type)',
      tooltip: 'placeBlock',
    },
    {
      text: 'getBlockInFront()',
      tooltip: 'getBlockInFront',
    },
    {
      text: 'getPos()',
      tooltip: 'getPos',
    },
    {
      text: 'destroy()',
      tooltip: 'destroy',
    },
    {
      text: 'item()',
      tooltip: 'item',
    },
    {
      text: 'pickItem([material])',
      tooltip: 'pickItem',
    },
    {
      text: 'putItem([material])',
      tooltip: 'putItem',
    },
    {
      text: 'useItem()',
      tooltip: 'useItem',
    },
    {
      text: 'takeItem(slot, amount, direction)',
      tooltip: 'takeItem',
    },
    {
      text: 'shootArrow()',
      tooltip: 'shootArrow',
    },
    {
      text: 'getInventory()',
      tooltip: 'getInventory',
    },
    {
      text: 'inventoryContains(item)',
      tooltip: 'inventoryContains',
    },
    {
      text: 'dropItem(material, amount)',
      tooltip: 'dropItem',
    },
    {
      text: 'startDrawing()',
      tooltip: 'startDrawing',
    },
    {
      text: 'setParticle(particle)',
      tooltip: 'setParticle',
    },
    {
      text: 'stopDrawing()',
      tooltip: 'stopDrawing',
    },
    {
      text: 'equip(slot)',
      tooltip: 'equip',
    },
    {
      text: 'unequip()',
      tooltip: 'unequip',
    },
  ],
  blocks: [
    {
      text: 'AIR',
      tooltip: 'AIR',
    },
    {
      text: 'STONE',
      tooltip: 'STONE',
    },
    {
      text: 'GRASS',
      tooltip: 'GRASS',
    },
    {
      text: 'DIRT',
      tooltip: 'DIRT',
    },
    {
      text: 'COBBLESTONE',
      tooltip: 'COBBLESTONE',
    },
    {
      text: 'WOOD_PLANKS',
      tooltip: 'WOOD_PLANKS',
    },
    {
      text: 'SAPLING',
      tooltip: 'SAPLING',
    },
    {
      text: 'BEDROCK',
      tooltip: 'BEDROCK',
    },
    {
      text: 'WATER_FLOWING',
      tooltip: 'WATER_FLOWING',
    },
    {
      text: 'WATER',
      tooltip: 'WATER',
    },
    {
      text: 'WATER_STATIONARY',
      tooltip: 'WATER_STATIONARY',
    },
    {
      text: 'LAVA_FLOWING',
      tooltip: 'LAVA_FLOWING',
    },
    {
      text: 'LAVA',
      tooltip: 'LAVA',
    },
    {
      text: 'LAVA_STATIONARY',
      tooltip: 'LAVA_STATIONARY',
    },
    {
      text: 'SAND',
      tooltip: 'SAND',
    },
    {
      text: 'GRAVEL',
      tooltip: 'GRAVEL',
    },
    {
      text: 'GOLD_ORE',
      tooltip: 'GOLD_ORE',
    },
    {
      text: 'IRON_ORE',
      tooltip: 'IRON_ORE',
    },
    {
      text: 'COAL_ORE',
      tooltip: 'COAL_ORE',
    },
    {
      text: 'WOOD',
      tooltip: 'WOOD',
    },
    {
      text: 'LEAVES',
      tooltip: 'LEAVES',
    },
    {
      text: 'GLASS',
      tooltip: 'GLASS',
    },
    {
      text: 'LAPIS_LAZULI_ORE',
      tooltip: 'LAPIS_LAZULI_ORE',
    },
    {
      text: 'LAPIS_LAZULI_BLOCK',
      tooltip: 'LAPIS_LAZULI_BLOCK',
    },
    {
      text: 'SANDSTONE',
      tooltip: 'SANDSTONE',
    },
    {
      text: 'BED',
      tooltip: 'BED',
    },
    {
      text: 'COBWEB',
      tooltip: 'COBWEB',
    },
    {
      text: 'GRASS_TALL',
      tooltip: 'GRASS_TALL',
    },
    {
      text: 'WOOL',
      tooltip: 'WOOL',
    },
    {
      text: 'FLOWER_YELLOW',
      tooltip: 'FLOWER_YELLOW',
    },
    {
      text: 'FLOWER_RED',
      tooltip: 'FLOWER_RED',
    },
    {
      text: 'MUSHROOM_BROWN',
      tooltip: 'MUSHROOM_BROWN',
    },
    {
      text: 'MUSHROOM_RED',
      tooltip: 'MUSHROOM_RED',
    },
    {
      text: 'GOLD_BLOCK',
      tooltip: 'GOLD_BLOCK',
    },
    {
      text: 'IRON_BLOCK',
      tooltip: 'IRON_BLOCK',
    },
    {
      text: 'STONE_SLAB_DOUBLE',
      tooltip: 'STONE_SLAB_DOUBLE',
    },
    {
      text: 'STONE_SLAB',
      tooltip: 'STONE_SLAB',
    },
    {
      text: 'BRICK_BLOCK',
      tooltip: 'BRICK_BLOCK',
    },
    {
      text: 'TNT',
      tooltip: 'TNT',
    },
    {
      text: 'BOOKSHELF',
      tooltip: 'BOOKSHELF',
    },
    {
      text: 'MOSS_STONE',
      tooltip: 'MOSS_STONE',
    },
    {
      text: 'OBSIDIAN',
      tooltip: 'OBSIDIAN',
    },
    {
      text: 'TORCH',
      tooltip: 'TORCH',
    },
    {
      text: 'FIRE',
      tooltip: 'FIRE',
    },
    {
      text: 'STAIRS_WOOD',
      tooltip: 'STAIRS_WOOD',
    },
    {
      text: 'CHEST',
      tooltip: 'CHEST',
    },
    {
      text: 'DIAMOND_ORE',
      tooltip: 'DIAMOND_ORE',
    },
    {
      text: 'DIAMOND_BLOCK',
      tooltip: 'DIAMOND_BLOCK',
    },
    {
      text: 'CRAFTING_TABLE',
      tooltip: 'CRAFTING_TABLE',
    },
    {
      text: 'FARMLAND',
      tooltip: 'FARMLAND',
    },
    // {
    //   text: 'FURNACE_INACTIVE',
    //   tooltip: 'FURNACE_INACTIVE'
    // },
    // {
    //   text: 'FURNACE_ACTIVE',
    //   tooltip: 'FURNACE_ACTIVE'
    // },
    {
      text: 'DOOR_WOOD',
      tooltip: 'DOOR_WOOD',
    },
    {
      text: 'LADDER',
      tooltip: 'LADDER',
    },
    {
      text: 'STAIRS_COBBLESTONE',
      tooltip: 'STAIRS_COBBLESTONE',
    },
    {
      text: 'DOOR_IRON',
      tooltip: 'DOOR_IRON',
    },
    {
      text: 'REDSTONE_ORE',
      tooltip: 'REDSTONE_ORE',
    },
    {
      text: 'SNOW',
      tooltip: 'SNOW',
    },
    {
      text: 'ICE',
      tooltip: 'ICE',
    },
    {
      text: 'SNOW_BLOCK',
      tooltip: 'SNOW_BLOCK',
    },
    {
      text: 'CACTUS',
      tooltip: 'CACTUS',
    },
    {
      text: 'CLAY',
      tooltip: 'CLAY',
    },
    {
      text: 'SUGAR_CANE',
      tooltip: 'SUGAR_CANE',
    },
    {
      text: 'FENCE',
      tooltip: 'FENCE',
    },
    {
      text: 'GLOWSTONE_BLOCK',
      tooltip: 'GLOWSTONE_BLOCK',
    },
    {
      text: 'BEDROCK_INVISIBLE',
      tooltip: 'BEDROCK_INVISIBLE',
    },
    {
      text: 'STONE_BRICK',
      tooltip: 'STONE_BRICK',
    },
    {
      text: 'GLASS_PANE',
      tooltip: 'GLASS_PANE',
    },
    {
      text: 'MELON',
      tooltip: 'MELON',
    },
    {
      text: 'FENCE_GATE',
      tooltip: 'FENCE_GATE',
    },
    {
      text: 'HAY_BLOCK',
      tooltip: 'HAY_BLOCK',
    },
  ],
  particles: [
    {
      text: 'CRIT_MAGIC',
    },
    {
      text: 'DRIP_WATER',
    },
    {
      text: 'VILLAGER_ANGRY',
    },
    {
      text: 'VILLAGER_HAPPY',
    },
    {
      text: 'NOTE',
    },
    {
      text: 'ENCHANTMENT_TABLE',
    },
    {
      text: 'FLAME',
    },
    {
      text: 'REDSTONE',
    },
    {
      text: 'HEART',
    },
  ],
  weather: [
    {
      text: 'CLEAR',
    },
    {
      text: 'DOWNFALL',
    },
  ],
  directions: [
    { text: 'FORWARD' },
    { text: 'BACK' },
    { text: 'LEFT' },
    { text: 'RIGHT' },
    { text: 'UP' },
    { text: 'DOWN' },
    { text: 'NORTH' },
    { text: 'SOUTH' },
    { text: 'EAST' },
    { text: 'WEST' },
  ],
  colors: [
    { text: 'WHITE' },
    { text: 'ORANGE' },
    { text: 'MAGENTA' },
    { text: 'LIGHT_BLUE' },
    { text: 'YELLOW' },
    { text: 'LIME' },
    { text: 'PINK' },
    { text: 'GRAY' },
    { text: 'LIGHT_GRAY' },
    { text: 'CYAN' },
    { text: 'PURPLE' },
    { text: 'BLUE' },
    { text: 'BROWN' },
    { text: 'GREEN' },
    { text: 'RED' },
    { text: 'BLACK' },
  ],
  rails: [
    { text: 'EAST_WEST' },
    { text: 'NORTH_SOUTH' },
    { text: 'NORTH_EAST' },
    { text: 'NORTH_WEST' },
    { text: 'SOUTH_EAST' },
    { text: 'SOUTH_WEST' },
    { text: 'ASCENDING_EAST' },
    { text: 'ASCENDING_NORTH' },
    { text: 'ASCENDING_SOUTH' },
    { text: 'ASCENDING_WEST' },
  ],
  creatures: [
    { text: 'SQUID', tooltip: 'SQUID' },
    // { text: 'SPIDER', tooltip: 'SPIDER' },
    // { text: 'ZOMBIE', tooltip: 'ZOMBIE' },
    // { text: 'PIG_ZOMBIE', tooltip: 'PIG_ZOMBIE' },
    { text: 'BAT', tooltip: 'BAT' },
    { text: 'BOAT', tooltip: 'BOAT' },
    { text: 'CHICKEN', tooltip: 'CHICKEN' },
    { text: 'COW', tooltip: 'COW' },
    { text: 'DONKEY', tooltip: 'DONKEY' },
    { text: 'DRAGON_FIREBALL', tooltip: 'DRAGON_FIREBALL' },
    { text: 'EGG', tooltip: 'EGG' },
    { text: 'FIREBALL', tooltip: 'FIREBALL' },
    { text: 'HORSE', tooltip: 'HORSE' },
    { text: 'IRON_GOLEM', tooltip: 'IRON_GOLEM' },
    { text: 'LIGHTNING', tooltip: 'LIGHTNING' },
    { text: 'LLAMA', tooltip: 'LLAMA' },
    { text: 'MINECART', tooltip: 'MINECART' },
    { text: 'MULE', tooltip: 'MULE' },
    { text: 'MUSHROOM_COW', tooltip: 'MUSHROOM_COW' },
    { text: 'OCELOT', tooltip: 'OCELOT' },
    { text: 'PARROT', tooltip: 'PARROT' },
    { text: 'PIG', tooltip: 'PIG' },
    { text: 'POLAR_BEAR', tooltip: 'POLAR_BEAR' },
    { text: 'PRIMED_TNT', tooltip: 'PRIMED_TNT' },
    { text: 'RABBIT', tooltip: 'RABBIT' },
    { text: 'SHEEP', tooltip: 'SHEEP' },
    { text: 'SMALL_FIREBALL', tooltip: 'SMALL_FIREBALL' },
    { text: 'SNOWBALL', tooltip: 'SNOWBALL' },
    { text: 'SNOWMAN', tooltip: 'SNOWMAN' },
    { text: 'SPLASH_POTION', tooltip: 'SPLASH_POTION' },
    { text: 'VILLAGER', tooltip: 'VILLAGER' },
    { text: 'WOLF', tooltip: 'WOLF' },
    { text: 'MINECART', tooltip: 'MINECART' },
    { text: 'MINECART_CHEST', tooltip: 'MINECART_CHEST' },
    { text: 'MINECART_FURNACE', tooltip: 'MINECART_FURNACE' },
    { text: 'MINECART_TNT', tooltip: 'MINECART_TNT' },
  ],
  items: [
    {
      text: 'DIAMOND',
    },
    {
      text: 'IRON_INGOT',
    },
    {
      text: 'GOLD_INGOT',
    },
    {
      text: 'WHEAT_SEEDS',
    },
    {
      text: 'WHEAT',
    },
    {
      text: 'REDSTONE',
    },
    {
      text: 'COAL',
    },
    {
      text: 'REEDS',
    },
    {
      text: 'EGG',
    },
    {
      text: 'BONE_MEAL',
    },
    {
      text: 'EMERALD',
    },
    {
      text: 'CARROT',
    },
    {
      text: 'POTATO',
    },
  ],
};
